import SelectFilterModal from './SelectFilterModal'
import useTypFilterModal from '../hooks/useTypFilterModal'

export default function TypFilterModal({
	isOpen,
	onClose,
	selectedTypId,
	onApply,
	title = 'Filtruj po typie placowki',
	description = 'Wybierz typ placowki, aby zawezic liste.',
	applyLabel = 'Zastosuj',
	clearLabel = 'Wyczysc filtr',
}) {
	const state = useTypFilterModal(isOpen, selectedTypId)
	return (
		<SelectFilterModal
			isOpen={isOpen}
			onClose={onClose}
			onApply={onApply}
			title={title}
			description={description}
			placeholder="Szukaj typu po nazwie..."
			emptyMessage="Nie znaleziono typow placowek"
			labelAccessor={item => item?.typ || '-'}
			applyLabel={applyLabel}
			clearLabel={clearLabel}
			{...state}
		/>
	)
}
